export const createDestroyTabulator = () => {
  return tabulatorInstanceRef => {
    if (tabulatorInstanceRef.current) {
      try {
        tabulatorInstanceRef.current.destroy();
      } catch (error) {
        console.warn('Error destroying Tabulator (might already be destroyed or DOM removed):', error);
      } finally {
        tabulatorInstanceRef.current = null;
      }
    }
  };
};

export const createPersistenceKeys = categoryTitle => {
  return [
    `tabulator-policy-review-${categoryTitle}-table-1-columns`,
    `tabulator-policy-review-${categoryTitle}-table-2-columns`,
    `tabulator-policy-review-${categoryTitle}-table-3-columns`,
    `tabulator-policy-review-${categoryTitle}-table-1-sort`,
    `tabulator-policy-review-${categoryTitle}-table-2-sort`,
    `tabulator-policy-review-${categoryTitle}-table-3-sort`
  ];
};

export const createRemoveLocalStoragePersistence = persistenceKeys => {
  return () => {
    persistenceKeys.forEach(key => localStorage.removeItem(key));
  };
};

export const createRecordTableHeight = (tableContainerRef, setTableHeight) => {
  return () => {
    if (tableContainerRef.current) {
      const height = tableContainerRef.current.offsetHeight;
      if (height > 0) {
        setTableHeight(height);
      }
    }
  };
};
